module.exports = function (data) {
    return {
        event: 'BWScrossSellCartAdded',
        eventContext: {
            area: data.area,
            unitprice: data.product.SalePrice || data.product.Price,
            unitDisplay: data.product.Unit,
            productInfo: data.product.ProductData,
            isOnSpecial: data.product.IsSpecial ? 'true' : 'false',
            typeOfCrossSell: 'google shop'
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/atm-mapper-cross-sell-cart.js
 **/